// extracted by mini-css-extract-plugin
module.exports = {"comment":"styles_comment__k4NjN","mention":"styles_mention__2jzJQ","comment__input":"styles_comment__input__3NyPA"};